export default class OrderManagerView
{
    constructor()
    {

        document.querySelector("#popup")?.addEventListener("click", e => {
            let popup = new BX.CDialog({
                'title': BX.message("LPOST_DELIVERY_TITLE_POPUP_EDIT_DELIVERY"),
                'content': BX('content'),
                'width': 600,
                'height': 700,
                'buttons': [
                    // BX.CDialog.prototype.btnClose,
                ]
            });
            popup.Show();
        })

        document.body.insertAdjacentHTML('beforeend' , `<div style="display: none"><div id="form-delivery-order-edit"></div></div>`);
        BX.onCustomEvent("eventPopupReady");
    }
}